import './divider.styles.scss'
import { JSX } from 'react'

export const Divider = (): JSX.Element => {
  return <div className='divider'></div>
}
